var TransportType;
(function(TransportType2) {
  TransportType2["XHR"] = "xhr";
  TransportType2["SendBeacon"] = "beacon";
  TransportType2["Fetch"] = "fetch";
})(TransportType || (TransportType = {}));
export {
  TransportType
};
//# sourceMappingURL=transport.js.map
